/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InstallationCategorieReportingDto } from '../../models/installation-categorie-reporting-dto';

export interface GetCategorieReportingP1ByIdInstallations$Params {
  body: Array<string>;
}

export function getCategorieReportingP1ByIdInstallations(
  http: HttpClient,
  rootUrl: string,
  params: GetCategorieReportingP1ByIdInstallations$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<InstallationCategorieReportingDto>>> {
  const rb = new RequestBuilder(rootUrl, getCategorieReportingP1ByIdInstallations.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InstallationCategorieReportingDto>>;
    })
  );
}

getCategorieReportingP1ByIdInstallations.PATH = '/v1/reportings_p1/categories';
